/* This file is autogenerated, see readme.md for instructions */
import TextItalicSvgIcon from '@bloomreach/banana-theme/icons/text-italic.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const TextItalicIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <TextItalicSvgIcon />
    </Icon>
  );
});

TextItalicIcon.displayName = 'TextItalicIcon';

export default TextItalicIcon;
